import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign, Gift, Headphones, TrendingUp } from 'lucide-react';

const benefits = [
  {
    icon: DollarSign,
    get title() { return translateInterfaceText("Comissão Recorrente"); },
    get description() { return translateInterfaceText("Ganhe 20% de comissão sobre tudo enquanto o cliente estiver ativo."); }
  },
  {
    icon: Gift,
    get title() { return translateInterfaceText("Desconto Exclusivo para Seus Clientes"); },
    get description() { return translateInterfaceText("Ofereça vantagens especiais para quem comprar com você (ex. bônus exclusivo com link)."); }
  },
  {
    icon: Headphones,
    get title() { return translateInterfaceText("Suporte Prioritário"); },
    get description() { return translateInterfaceText("Tenha atendimento exclusivo para parceiros."); }
  },
  {
    icon: TrendingUp,
    get title() { return translateInterfaceText("Maior Autoridade e Visibilidade"); },
    get description() { return translateInterfaceText("Indique e Ganhe e aumente seu valor para o Email."); }
  }
];

export function ReferralBenefits() {
  useLanguage();
  return (
    <section className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl lg:text-2xl font-bold text-foreground">
          {translateInterfaceText("Benefícios do Programa")}</h3>
        <p className="text-muted-foreground">
          {translateInterfaceText("Vantagens exclusivas para parceiros Host VSL")}</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {benefits.map((benefit) => (
          <Card key={benefit.title} className="text-center">
            <CardHeader>
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto mb-2">
                <benefit.icon className="w-6 h-6 text-primary" />
              </div>
              <CardTitle className="text-base">{benefit.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                {benefit.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
